import React from 'react'
import CustomModal from 'components/global/CustomModal'
import { eventCommonStore } from 'state/event/eventCommon'
import useFormSubmit from 'helper/Hooks/formSubmit'
import CustomModalFooter from 'components/global/CustomModalFooter'
import AddQuestionContent from '../ModalCotent/AddQuestion'

interface AddQuestionProps {
  referenceModalId: string
  reference: 'event' | 'organization' | 'league' | 'class'
}

const AddQuestion: React.FC<AddQuestionProps> = ({
  referenceModalId,
  reference,
}) => {
  const { form, handleSubmit } = useFormSubmit()
  const { addQuestionModal, setAddQuestionModal, faqData, setFaqData } =
    eventCommonStore(store => ({
      addQuestionModal: store.addQuestionModal,
      setAddQuestionModal: store.setAddQuestionModal,
      faqData: store.faqData,
      setFaqData: store.setFaqData,
    }))

  return (
    <>
      <CustomModal
        title="Add Question"
        openModal={addQuestionModal}
        closeModal={(state: boolean) => {
          // Reset edit state on dismiss so a left-over FAQ never leaks into the next open.
          setFaqData(undefined)
          setAddQuestionModal(state)
        }}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnType="primary"
            btnText="Save"
            onSubmit={handleSubmit}
          />
        }
      >
        <AddQuestionContent
          form={form}
          reference={reference}
          referenceId={referenceModalId}
          data={faqData}
        />
      </CustomModal>
    </>
  )
}

export default AddQuestion
